import { AuthKey } from '@/auth';
import { useEffect, useRef, useState } from 'react';
import { useAppLocation } from '@/navigation';

type KeyType = AuthKey | boolean | null;

export const useLoginKey = () => {
  const keyRef = useRef<KeyType>(false);
  const location = useAppLocation();
  const locationRef = useRef(location.pathname);
  const [key, setKey] = useState<KeyType>(false);

  useEffect(() => {
    if (locationRef.current !== location.pathname || keyRef.current === false) {
      locationRef.current = location.pathname;
      const currentKey = new URLSearchParams(location.search).get('key');

      if (currentKey !== keyRef.current) {
        keyRef.current = currentKey;
        setKey(currentKey);
      }
    }
  }, [location]);

  return {
    key,
  };
};
